import { createContext, useContext } from "react";
import type { AdditionalContextStates } from "./types";

export const AdditionalContextInitialState: AdditionalContextStates = {
  filters: { selectedModuleGroup: undefined },
  setFilters: () => {},
};

const context = createContext<AdditionalContextStates>(
  AdditionalContextInitialState,
);
export const useAdditionalContext = () => useContext(context);
export const AdditionalContextProvider = context.Provider;
